import {useNavigation, useRoute} from '@react-navigation/native';
import {useEffect} from 'react';
import {imManager} from '@/common-pages/im/im.state';

export function useToChat() {
  const route = useRoute();
  const navigation = useNavigation();
  useEffect(() => {
    const params: any = route.params;
    if (params && params.toChat) {
      imManager.setVisibleState(true, {
        customerId: params.toChat,
      });
      navigation.setParams({
        ...params,
        toChat: void 0,
      });
      return;
    }
    if (params && params.chatPage) {
      imManager.setVisibleState(true);
      navigation.setParams({
        ...params,
        chatPage: void 0,
      });
      return;
    }
  }, [route.params, navigation]);
}
